module.exports = __webpack_public_path__ + "img/fr.21c629e9.svg";